import { Skeleton } from '@crowdfpl/ui-web/skeleton';

export function NotificationSkeleton() {
  return (
    <div className="flex gap-3 px-3 py-2.5">
      <Skeleton className="h-5 w-5 shrink-0 rounded-full" />
      <div className="min-w-0 flex-1 space-y-2">
        <Skeleton className="h-3.5 w-3/4" />
        <Skeleton className="h-3 w-full" />
      </div>
      <Skeleton className="h-3 w-10 shrink-0" />
    </div>
  );
}
